import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../core/services/api.service';
import { PagedResult } from '../../core/models/api.models';
import { RoleDto } from '../admin/admin.models';

export interface UserListItemDto {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  displayName?: string;
  phone?: string;
  status?: number;
  isSuperAdmin?: boolean;
  lastLoginAt?: string;
  roles?: string[];
  roleIds?: string[];
}

export interface UserDetailDto extends UserListItemDto {
  roles: string[];
  roleIds?: string[];
}

@Injectable({ providedIn: 'root' })
export class UsersService {
  private readonly api = inject(ApiService);

  list(params?: { page?: number; pageSize?: number; search?: string }): Observable<PagedResult<UserListItemDto>> {
    return this.api.getPaged<UserListItemDto>('users', {
      page: params?.page ?? 1,
      pageSize: params?.pageSize ?? 50,
      search: params?.search
    });
  }

  getById(id: string): Observable<UserDetailDto> {
    return this.api.get<UserDetailDto>(`users/${id}`);
  }

  listRoles(): Observable<RoleDto[]> {
    return this.api.get<RoleDto[]>('roles');
  }

  assignRoles(userId: string, roleIds: string[]): Observable<UserDetailDto> {
    return this.api.put<UserDetailDto>(`users/${userId}/roles`, { roleIds });
  }
}
